import { render, staticRenderFns } from "./UsersCreateComponent.vue?vue&type=template&id=c3704eb6"
import script from "./UsersCreateComponent.vue?vue&type=script&lang=js"
export * from "./UsersCreateComponent.vue?vue&type=script&lang=js"
import style0 from "./UsersCreateComponent.vue?vue&type=style&index=0&id=c3704eb6&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports